module.exports = __webpack_public_path__ + "static/img/banner3-4.a75db74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner3-4.jpg
// module id = uZsS
// module chunks = 1